import { createContext, ReactNode, useContext } from "react";
export type LocalesProps = {
    selectedLocales: Record<string, any> | null;
    setSelectedLocales: React.Dispatch<
        React.SetStateAction<Record<string, any> | null>>;
};
export const LocalesContext = createContext<LocalesProps | null>({} as LocalesProps);
export function useLocales() {
    const ctx = useContext(LocalesContext);
    return ctx;
}
export default function LocalesProvider({
  value,
  children,
}: {
  value: LocalesProps;
  children: ReactNode;
}): JSX.Element {
  return (
    <LocalesContext.Provider value={value}>{children}</LocalesContext.Provider>
  );
}
export const useTranslator = (file: string) => {
  const { selectedLocales } = useLocales() as LocalesProps;
  if (selectedLocales && file) {
    const localeEdge = selectedLocales.locales?.edges?.find((edge: { node: { ns: string } }) => edge.node.ns === file );
    return (localeEdge ? JSON.parse(localeEdge.node.data) : null);
  }
  return null;
};
